import React from 'react';
import { FormattedMessage } from 'react-intl';

export const validatePasscode = (value) => {
  if (value) {
    if (value.match(/\D/)) {
      return (
        <FormattedMessage
          id="components.contacts.meetingModal.passcodeError"
          defaultMessage="Passcode must be numeric."
        />
      );
    }

    if (value.length < 4) {
      return (
        <FormattedMessage
          id="components.contacts.meetingModal.passcodeLengthError"
          defaultMessage="Minimum four digits."
        />
      );
    }

    if (value.length > 10) {
      return (
        <FormattedMessage
          id="components.contacts.meetingModal.passcodeMaxLengthError"
          defaultMessage="Maximum ten digits."
        />
      );
    }
  }

  return undefined;
};

export const validateRequiredPasscode = (value) => {
  if (!value || value.trim().length === 0) {
    return (
      <FormattedMessage
        id="components.contacts.meetingModal.missingPinError"
        defaultMessage="A passcode is required."
      />
    );
  }

  return validatePasscode(value);
};
